import { apiEndpoints } from "src/config/config";
import { EnvironmentI } from "@config/iconfig";

export const environment: EnvironmentI = {
  production: true,
  //staging: appConfig.staging,//TODO: Descomentar cuando se publique en staging
  api: apiEndpoints
};
